// @flow
import React, { Component } from 'react';
import styled from 'styled-components';

import { type Notification } from 'apps/core/user/types';

import { stripLocalHostname } from 'utils/urls';
import FormattedTimeFromNow from 'components/FormattedTimeFromNow';
import ConditionalLink from 'components/ConditionalLink';
import Icon from 'components/Icon';

export const StyledNotificationList = styled.div`
    background: transparent !important;
    padding-top: 0;
    .card-body {
        padding-top: 0;
    }
    h3 {
        font-size: 1.25rem;
        margin-bottom: 0;
    }
    ul {
        margin: 1.1rem 0;
        padding: 0;
        li {
            background: ${props => props.theme.color.white};
            border-radius: 2px;
            line-height: 1.15rem;
            list-style: none;
            margin: 0 0 0.5rem;
            padding: 0.75rem 1rem;
            position: relative;
            small {
                font-style: italic;
                opacity: 0.5;
            }
            a,
            span {
                color: ${props => props.theme.color.text};
            }
        }
    }
    @media (max-width: 767px) {
        h3 {
            font-size: 1.75rem;
            border-bottom: 1px solid ${props => props.theme.color.border};
            padding-bottom: 1rem;
        }
        .dropdown-toggle::after {
            margin-left: -0.745em;
        }
        border-bottom: 1px solid ${props => props.theme.color.border};
    }
`;

type NotificationListProps = {
    notifications: Array<Notification>,
};

const NotificationItem = ({ notification }) => (
    <li>
        <ConditionalLink
            condition={window.location.href !== notification.url}
            to={stripLocalHostname(notification.url)}
        >
            {notification.title}
        </ConditionalLink>
        <br />
        {notification.created_at && (
            <small>
                <FormattedTimeFromNow date={notification.created_at} />
            </small>
        )}
    </li>
);

class NotificationList extends Component<NotificationListProps> {
    state = {
        display: false,
        // mobile first!
    };

    setDisplay = () => this.setState({ display: !this.state.display });

    render() {
        const { notifications, title = 'Notifications' } = this.props;
        const { display } = this.state;

        return (
            <StyledNotificationList id='notification-list'>
                {title ? <h3>{title}</h3> : null}
                {notifications.length ? (
                    <>
                        <span
                            onClick={this.setDisplay.bind(this)}
                            className={
                                !display ? 'w-100 my-3 d-block d-md-none' : 'd-none'
                            }
                            style={{ cursor: 'pointer' }}
                        >
                            <Icon name='bell' className='mr-2' />
                            Show notifications
                        </span>
                        <ul
                            className={
                                display
                                    ? 'list-unstyled d-block'
                                    : 'list-unstyled d-none d-md-block'
                            }
                        >
                            {notifications.map((n, i) => (
                                <NotificationItem key={i} notification={n} />
                            ))}
                        </ul>
                    </>
                ) : (
                    <span className='w-100 my-3 d-block'>No notifications</span>
                )}
            </StyledNotificationList>
        );
    }
}

export default NotificationList;
